import config from "@/config.js";
import V from "@/main";
// import { stat } from "fs";
// import { Store } from "vuex";
// import vaccinationBucket from "../../data/opd/VacinationBucket";
// import vaccinationSchedule from "../../data/opd/VaccinationSchedule";
// import _ from "lodash";

//
let baseState = {
  // vaccinationBucket: vaccinationBucket,
  // vaccinationSchedule: vaccinationSchedule,
  vaccinationBucket: [],
  vaccinationSchedule: [],
  opd: {
    status: "",
    past_medical_history: {},
    foetus_details: [],
    history: {
      obstetrics: {},
      gynaecology: {
        menses: {}
      }
    },
    finding_templates: [],
    findings: {
      general: {
        BP: {}
      },
      gynaecology: {},
      obstetricsANC: {
        findings: {},
        perimetry: {}
      }
    },
    charges: 0,
    advice: {
      services: [],
      stat_tests: [],
      diet_plan: {},
      refer_to: {}
    },
    complaint: {},
    saved_images: [],
    saved_prescriptions: [],
    uploaded_images: [],
    basicPrescription: {}
  },
  patientNotBrought: false,
  basicPrescription: false,
  patientBroughtDead: false,
  modal: false,
  isDeclaredDead: false,
  patientDetails: {}
};

let tempState = baseState;

import find from "lodash/find";
export default {
  namespaced: true,
  state: { ...baseState },
  getters: {
    getVaccinationBucket: state => {
      return state.vaccinationBucket;
    },
    VACCINATION_SCHEDULE: state => {
      return state.vaccinationSchedule;
    },
    getPatientDetails: state => {
      return state.patientDetails;
    },
    GET_CURRENT_OPD: state => {
      return state.opd;
    },
    GET_CURRENT_OPD_TRANSACTION: state => {
      return state.opd && state.opd.transaction_id;
    },
    GET_CURRENT_OPD_ID: state => {
      return state.opd && state.opd._id;
    },
    GET_CURRENT_OPD_TYPE: state => {
      return state.opd && state.opd && state.opd.opd_type;
    },
    GET_CURRENT_OPD_STATUS: state => {
      return state.opd && state.opd.status;
    }
  },
  mutations: {
    setOpdStatusPaymentDone(state, payload) {
      state.opd.status = payload;
    },
    saveVaccinationDetails(state, dtp) {
      if (dtp.type == "reschedule") {
        let object = find(state.vaccinationBucket, function(obj) {
          return dtp.duration === obj.duration;
        });
        let index = object.vaccines.findIndex(x => x.id === dtp.id);
        object.vaccines.splice(index, 1);
      }
      let object = find(state.vaccinationBucket, function(obj) {
        return dtp.totalDays <= obj.upperLimitDays;
      });
      object.vaccines.push(dtp);
    },
    updateVaccinationOnload(state, vaccination) {
      state.vaccinationBucket = vaccination;
    },
    updateVaccinationSchedule(state, schedule) {
      state.vaccinationSchedule = schedule;
    },
    setDetails(state, details) {
      state.opd = details;
    },
    modalMode(state, mode) {
      state.mode = mode;
    },
    setOpdDetails(state, payload) {
      state.opd = payload.data;
    },
    opdPatientDetails(state, payload) {
      state.patientDetails = payload;
    },
    setDeclaredDead(state, payload) {
      state.isDeclaredDead = payload;
    },
    updateBaseState(state, payload) {
      state.opd = payload;
    }
  },
  actions: {
    resetBaseState(context) {
      context.commit("updateBaseState", { ...baseState });
    },
    updateVaccinationOnload(context, payload) {
      context.commit("updateVaccinationOnload", payload);
    },
    updateVaccinationSchedule(context, payload) {
      context.commit("updateVaccinationSchedule", payload);
    },
    saveVaccinationDetails(context, payload) {
      context.commit("saveVaccinationDetails", payload);
    },
    getOPDDetails(context, payload) {
      if (payload.patientId && payload.opdId) {
        V.$http
          .get(
            //`${config.BASE_URL}api/v1/opd/details/${payload.patientId}/${payload.opdId}`,
            `${config.NEW_BASE_URL}api/v2/opd/details/${payload.patientId}/${payload.opdId}`,
            {}
          )
          .then(res => {
            context.commit("setOpdDetails", res.data);
          })
          .catch(err => console.log(err));
      }
    },
    saveOPD(context, payload) {
      if (payload.patientId && payload.opdId) {
        return V.$http
          .post(
            //`${config.BASE_URL}api/v1/opd/save/${payload.patientId}/${payload.opdId}`,
            `${config.NEW_BASE_URL}api/v2/opd/save/${payload.patientId}/${payload.opdId}`,
            payload.opdDetails,
            {}
          )
          .then(res => {
            if (res.data.status == 1) {
              context.commit("setDetails", payload.opdDetails);
            }
          })
          .catch(err => console.log(err));
      }
    },
    OPDDetails(context, payload) {
      context.commit("setOpdDetails", payload);
    },
    setDeclaredDead(context, payload) {
      context.commit("setDeclaredDead", payload);
    }
  }
};
